module.exports = __webpack_public_path__ + "static/img/ABUIABACGAAgyL7xkQYoiM_cnwQwwAI48AE.214ee00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABACGAAgyL7xkQYoiM_cnwQwwAI48AE.jpg
// module id = +czG
// module chunks = 1